module.exports = __webpack_public_path__ + "static/media/other_actions.ef5dc9fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/other_actions.svg
// module id = 363
// module chunks = 0